import {
  SalaryCardActions,
  SalaryCardActionTypes,
  SalaryCardState,
} from 'store/types/salaryCard'

const initialState: SalaryCardState = {
  businessCardList: [],
  businessCardListError: null,
  businessCardListStatus: 'idle',
}

export const bussinessCardListReducers = (
  state = initialState,
  action: SalaryCardActions
): SalaryCardState => {
  switch (action.type) {
    case SalaryCardActionTypes.FETCH_BUSSINESS_CARDS_REQUEST:
      return {
        ...state,
        businessCardListStatus: 'loading',
      }
    case SalaryCardActionTypes.FETCH_BUSSINESS_CARDS_SUCCESS:
      return {
        ...state,
        businessCardListStatus: 'success',
        businessCardList: action.payload,
      }
    case SalaryCardActionTypes.FETCH_BUSSINESS_CARDS_FAILURE:
      return {
        ...state,
        businessCardListStatus: 'failed',
        businessCardListError: action.payload,
      }
    default:
      return state
  }
}
